// import PropTypes from "prop-types";

import ChartkickChart from "../../../shared_components/chartkick_chart";

class CitiesHistogramChart extends ChartkickChart {
}

CitiesHistogramChart.propTypes = Object.assign({}, ChartkickChart.propTypes, {

});

export default CitiesHistogramChart;
